// src/components/Header.js
// Updated: 11/10/2025 09:50 PM EST
// --- COPY-PASTE THIS ENTIRE FILE ---

import React from 'react';
import { useNavigate, Link } from 'react-router-dom'; // Added Link
import { useAuth } from '../context/AuthContext';
import { LogOut, UserCircle } from 'lucide-react'; // Added UserCircle icon

export default function Header() {
  const { currentUser, userData, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (err) {
      console.error('Logout Error:', err);
      alert('Failed to log out.');
    }
  };

  return (
    <header className="flex h-20 flex-shrink-0 items-center justify-between border-b bg-white px-6">
      <h2 className="text-2xl font-semibold text-gray-800">Dashboard</h2>

      <div className="flex items-center space-x-4">
        <div className="text-right">
          <div className="font-medium text-gray-900">
            {currentUser?.displayName || 'User'}
          </div>
          <div className="text-sm text-gray-500">
            {userData?.role ? userData.role.toUpperCase() : 'Member'}
          </div>
        </div>
        
        {/* --- NEW: Profile Link --- */}
        <Link
          to="/profile"
          title="My Profile"
          className="rounded-full p-2 text-gray-500 hover:bg-gray-100 hover:text-blue-600 focus:outline-none focus:ring"
        >
           <UserCircle className="h-6 w-6" />
        </Link>
        {/* --- END NEW LINK --- */}

        <button
          onClick={handleLogout}
          title="Log Out"
          className="rounded-full p-2 text-gray-500 hover:bg-gray-100 hover:text-red-600 focus:outline-none focus:ring"
        >
          <LogOut className="h-6 w-6" />
        </button>
      </div>
    </header>
  );
}